import { render, staticRenderFns } from "./LanguageSelectionDialog.vue?vue&type=template&id=7623f290"
import script from "./LanguageSelectionDialog.vue?vue&type=script&lang=ts"
export * from "./LanguageSelectionDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports